import { useState } from "react";
import { get, omit } from "lodash";
import { connect } from "react-redux";

import { setServerValidation } from "redux/actions/main";

import { EyeIcon, EyeOffIcon } from "@heroicons/react/solid";

const InputFormV2 = ({
  label,
  labelClassName,
  parentClassName,
  parentInputClassName,
  id,
  isRequired,
  inputClassName,
  type = "text",
  placeholder,
  isPastDateDisabled,
  name,
  disabled,
  formik,
  serverValidation,
  autocomplete,
  serverValidationKey,
  sideEffect,
  helperText,
  setServerValidation
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const errorMessage = get(formik.errors, id);
  // serverValidationKey is used for displaying errors from other key
  const serverErrorMessage = get(serverValidation, serverValidationKey || id);
  const defaultValue = get(formik.values, id);
  const touched = get(formik.touched, id);
  const handleRemoveServerValidation = () => {
    const removeKey = omit(serverValidation, serverValidationKey || id);
    setServerValidation(removeKey);
  }
  return (
    <div className={`form-group ${parentClassName}`}>
      {label && (
        <label htmlFor={id} className={`field-label ${labelClassName}`}>
          {label}&nbsp;
          {isRequired && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className={`w-full ${parentInputClassName}`}>
        {type === "textarea" ? (
          <textarea
            className={`form-control ${inputClassName}`}
            name={name}
            id={id}
            cols="30"
            rows="10"
            defaultValue={defaultValue}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={disabled}
            autoComplete={autocomplete}
          />
        ) : type === "password" ? (
          <div className="relative">
            <input
              className={`form-control pr-10 ${inputClassName}`}
              type={showPassword ? "text" : "password"}
              id={id}
              placeholder={placeholder}
              name={name}
              disabled={disabled}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              defaultValue={defaultValue}
              autoComplete={autocomplete}
            />
            {showPassword ? (
              <EyeIcon
                className="absolute h-5 w-5 top-0 bottom-0 my-auto right-4 cursor-pointer text-maroon"
                onClick={() => setShowPassword(false)}
              />
            ) : (
              <EyeOffIcon
                className="absolute h-5 w-5 top-0 bottom-0 my-auto right-4 cursor-pointer text-maroon"
                onClick={() => setShowPassword(true)}
              />
            )}
          </div>
        ) : (
          <input
            className={`form-control ${inputClassName}`}
            type={type === "decimal" ? "number" : type}
            id={id}
            placeholder={placeholder}
            min={
              type == "date" && isPastDateDisabled
                ? new Date().toISOString().split("T")[0]
                : null
            }
            name={name}
            disabled={disabled}
            onChange={(e) => {
              formik.handleChange(e);
              if (sideEffect) sideEffect(e);
              if (serverErrorMessage) handleRemoveServerValidation();
            }}
            onBlur={formik.handleBlur}
            defaultValue={defaultValue}
            autoComplete={autocomplete}
          />
        )}
        {touched && errorMessage && (
          <div className="help-block text-red-400 mt-2 whitespace-pre-line">
            {errorMessage}
          </div>
        )}
        {serverErrorMessage && (
          <div className="help-block text-red-400 mt-2 whitespace-pre-line">
            {serverErrorMessage}
          </div>
        )}
        {helperText && (
          <div className="help-block !text-sm text-gray-500 mt-2 whitespace-pre-line">
            {helperText}
          </div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  serverValidation: state.mainReducer.serverValidation,
});

const mapDispatchToProps = {
  setServerValidation,
};

export default connect(mapStateToProps, mapDispatchToProps)(InputFormV2);
